import { IonCheckbox } from "@ionic/react";
import { type ReactNode } from "react";

interface ShiftBoxProps {
  /** Shift title/function name */
  title: string;
  /** Time range (e.g., "12:00 - 18:00") */
  timeRange: string;
  /** Whether the checkbox is checked */
  checked: boolean;
  /** Callback when checkbox state changes */
  onCheckedChange: (checked: boolean) => void;
  /** Optional additional content to display */
  children?: ReactNode;
  /** Jouw stand op deze dienst ("Aangemeld", "Bevestigd"), als je je hierop hebt aangemeld. */
  claimLabel?: string;
  /**
   * Er valt hier niets te kiezen.
   *
   * Zo staan de diensten van een dag die al van jou is: zichtbaar, want ze zijn het bewijs dat je
   * aanmelding is aangekomen, maar niet meer aan te vinken -- je meldt je één keer per dag aan.
   */
  readOnly?: boolean;
}

export function ApplicationSignupShiftBox({
  title,
  timeRange,
  checked,
  onCheckedChange,
  children,
  claimLabel,
  readOnly = false,
}: ShiftBoxProps) {
  const handleClick = () => {
    if (readOnly) {
      return;
    }

    // Toggle to opposite of current state
    const newState = !checked;
    onCheckedChange(newState);
  };

  const isClaimed = !!claimLabel;

  return (
    <button
      type="button"
      disabled={readOnly}
      style={{
        boxSizing: "border-box",
      }}
      className={`flex w-full items-center justify-between rounded-xl border-[1px] border-solid p-4 transition-all ${
        isClaimed
          ? "border-success-100 bg-surface-primary"
          : readOnly
            ? "border-bordercolor-primary bg-surface-primary opacity-60"
            : checked
              ? "border-button-primary bg-surface-brand-secondary"
              : "border-button-primary bg-white"
      }`}
      onClick={handleClick}
    >
      <div className="flex flex-1 flex-col items-start gap-1 text-left">
        {title && (
          <span className="rounded-full bg-surface-brand-secondary px-2.5 py-1 text-xs font-semibold text-button-primary">
            {title}
          </span>
        )}
        <p className="text-base font-medium text-txt-tertiary">{timeRange}</p>
        {children}
      </div>
      {claimLabel && (
        <span className="shrink-0 rounded-full bg-success-10 px-2.5 py-1 text-xsm font-semibold text-success-120">
          {claimLabel}
        </span>
      )}

      {!readOnly && (
        <div
          className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md border-[1.5px] border-solid ${
            checked ? "border-button-primary bg-button-primary" : "border-button-primary bg-white"
          }`}
        >
          {checked && (
            <svg
              width="14"
              height="11"
              viewBox="0 0 14 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="text-txt-inverted"
            >
              <path
                d="M1.5 5.5L5 9L12.5 1.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </div>
      )}
    </button>
  );
}
